<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-2">
                <label>{{ $t('common_words.report_type') }} *</label>
                <br />
                <el-select
                  clearable
                  class="select-primary custom-width-select required-type shadow-sm"
                  size="large"
                  @change="ringingJournal = false"
                  v-model="ringingJournalForm.type"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    class="select-primary"
                    :value="0"
                    :label="$t('common_words.consolidated')"
                  ></el-option>
                  <el-option
                    class="select-primary"
                    :value="1"
                    :label="$t('common_words.detailed')"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  clearable
                  multiple
                  @change="
                    selectAllFromSelect('ringingJournalForm.farms', farms);
                    showCalendar();
                  "
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="ringingJournalForm.farms"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                v-if="isShowCalendar"
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-calendar shadow-sm"
                  size="large"
                  v-model="ringingJournalForm.calendar_sel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in calendars"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('common_words.analyze_by') }} </label>
                <br />
                <el-select
                  clearable
                  @change="changeByInterval"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="ringingJournalForm.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsInterval"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="
                  ringingJournalForm.bySel != 'week' &&
                  ringingJournalForm.bySel != 'year'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="rangeDate"
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  ringingJournalForm.bySel == 'week' ||
                  ringingJournalForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="ringingJournalForm.week_sel_init = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="ringingJournalForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  ringingJournalForm.bySel == 'week' &&
                  ringingJournalForm.year_sel_init
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="ringingJournalForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years[
                      ringingJournalForm.year_sel_init
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  ringingJournalForm.bySel == 'week' ||
                  ringingJournalForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="ringingJournalForm.week_sel_end = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="ringingJournalForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  ringingJournalForm.bySel == 'week' &&
                  ringingJournalForm.year_sel_end
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="ringingJournalForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years[
                      ringingJournalForm.year_sel_end
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
            <br />
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="ringingJournal"
      >
        <template slot="header">
          <div class="row">
            <div
              class="col-12 col-md-5 col-lg-4"
              style="
                display: flex;
                align-items: center;
                justify-content: flex-start;
              "
            >
              <h5 class="card-title mr-4">{{ titleCard }}</h5>
              <el-checkbox class="mt-1" v-model="percentage"
                >{{ $t('common_words.percentual_value') }}?
              </el-checkbox>
            </div>
          </div>
        </template>
        <div class="mt-4">
          <div class="row" v-if="isIndex()">
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr class="cusmtom-thead-color">
                    <td
                      v-for="(row, i) in table_columns"
                      :key="i"
                      class="text-center p-3 custom-header-label"
                      :style="'min-width:150px'"
                    >
                      <span v-if="row.label == '100'">{{
                        $t('production.young_mayus')
                      }}</span>
                      <span v-else-if="row.label == '200'">{{
                        $t('production.banana_flower_mayus')
                      }}</span>
                      <span v-else-if="row.prop">{{ getSemLabel(row) }}</span>
                    </td>
                    <td class="text-center p-3 custom-header-label">
                      {{ $t('common_words.total_mayus') }}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table_data" :key="i">
                    <td
                      class="text-center"
                      v-for="(col, j) in table_columns"
                      :key="j"
                    >
                      <template v-if="isColumnInfo(j) || !percentage">
                        {{ row[col.prop] }}
                      </template>
                      <template v-else-if="isColumnValue(j) && percentage">
                        <cell-percentage
                          :value="row[col.prop]"
                          :totalRow="
                            calculatPercentage(row[col.prop], row, i, col.prop)
                          "
                          :totalColumn="
                            calculatPercentage(
                              row[col.prop],
                              row,
                              i,
                              col.prop,
                              'column'
                            )
                          "
                        />
                      </template>
                    </td>
                    <td class="text-center">
                      <strong>{{ calculateTotalRow(row, i) }}</strong>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td
                      v-for="(col, j) in table_columns"
                      :key="j"
                      class="text-center"
                      v-if="col.prop != 'bysel'"
                      :colspan="
                        col.prop == 'type' && ringingJournalForm.type == 1
                          ? 2
                          : 1
                      "
                    >
                      <strong v-if="col.prop == 'type'">Gran Total</strong>
                      <strong v-else-if="col.prop == 'bysel'"></strong>
                      <strong v-else>{{
                        calculateTotalColumn(col.prop)
                      }}</strong>
                    </td>
                    <td class="text-center">
                      <strong>{{ calculateTotalColumn('all') }}</strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div class="row my-5" style="padding-right: 13px; padding-left: 13px">
            <div class="col-6" v-if="isPDF()">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportToPDF"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { MixinExport } from 'src/mixins/mixin-export';
import { RadioGroup, Radio, RadioButton } from 'element-ui';
import CellPercentage from '../CellPercentage';
import Formatter from 'src/class/Formatter';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    [CellPercentage.name]: CellPercentage,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [RadioGroup.name]: RadioGroup,
  },

  computed: {
    calendars() {
      if (this.ringingJournalForm.farms) {
        let calendars = [];
        this.farms.forEach((element) => {
          this.ringingJournalForm.farms.forEach((elFarm) => {
            if (element.id == elFarm) {
              calendars = element.calendars;
            }
          });
        });

        return calendars;
      } else {
        return [];
      }
    },
    optionsInterval() {
      return {
        0: { label: i18n.t('common_words.day'), value: 'daterange' },
        1: { label: i18n.t('common_words.week'), value: 'weekrange' },
        2: { label: i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: i18n.t('common_words.year'), value: 'year' },
      };
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  data() {
    return {
      ringingJournalForm: {
        type: null,
        farms: [],
        year_sel_init: null,
        week_sel_init: null,
        year_sel_end: null,
        week_sel_end: null,
        bySel: null,
        year_sel: null,
        calendar_sel: null,
        user_id: this.$store.state.auth.user.id,
      },
      typedatepicket: 'daterange',
      row: null,
      activeName: '1',
      valueCollapse: null,
      reports: [],
      interval: 'Semana',
      years: [],
      farms: [],
      flag: null,
      ringingJournal: false,
      isShowCalendar: false,
      table_data: [],
      table_columns: [],
      titleCard: '',
      totals: [],
      percentage: false,
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getSemLabel(row) {
      if (row.semLabel !== undefined && row.semLabel !== null) {
        return `${row.semLabel} ${this.$t('common_words.week_short')}`;
      }

      return row.label;
    },

    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },

    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    isColumnInfo(index) {
      return (
        (index === 0 && this.ringingJournalForm.type === 0) ||
        ([0, 1].includes(index) && this.ringingJournalForm.type === 1)
      );
    },

    isColumnValue(index) {
      return (
        (index > 0 && this.ringingJournalForm.type === 0) ||
        (index > 1 && this.ringingJournalForm.type === 1)
      );
    },

    showCalendar() {
      this.ringingJournalForm.calendar_sel = null;
      this.isShowCalendar = true;
      this.ringingJournal = false;
      for (let index = 0; index < Object.values(this.farms).length; index++) {
        const element = Object.values(this.farms)[index];

        this.ringingJournalForm.farms.forEach((elFarm) => {
          if (element.id != 0 && element.id == elFarm) {
            if (element.calendars.length > 1) this.isShowCalendar = true;
            else {
              if (element.calendars.length == 1) {
                this.ringingJournalForm.calendar_sel = element.calendars[0].id;
                this.isShowCalendar = false;
              }
            }
          }
        });
      }

      this.isShowCalendar = false;
    },

    changeByInterval() {
      this.ringingJournal = false;
      for (
        let index = 0;
        index < Object.values(this.optionsInterval).length;
        index++
      ) {
        const element = Object.values(this.optionsInterval)[index];
        if (element.label == this.ringingJournalForm.bySel) {
          this.typedatepicket = element.value;
          break;
        }
      }
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    validate() {
      if (this.ringingJournalForm.type == null) {
        return this.validationInputsRequired('type');
      } else if (
        this.ringingJournalForm.farms == null ||
        this.ringingJournalForm.farms.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (
        (this.ringingJournalForm.bySel == 'year' &&
          (this.ringingJournalForm.year_sel_init == null ||
            this.ringingJournalForm.year_sel_end == null)) ||
        (this.ringingJournalForm.bySel == 'week' &&
          this.isYearSelRequired() &&
          this.ringingJournalForm.year_sel_init == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.ringingJournalForm.week_sel_init == null &&
        this.ringingJournalForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.isYearSelRequired() &&
        this.ringingJournalForm.year_sel_end == null &&
        this.ringingJournalForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.ringingJournalForm.week_sel_end == null &&
        this.ringingJournalForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.ringingJournalForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else {
        this.loadRingingJournalReport();
      }
    },

    calculatPercentage(value, row, index, column, type = 'row') {
      let total = 1;
      if (type === 'row') {
        total = this.calculateTotalRow(row, index);
      }
      if (type === 'column') {
        total = this.calculateTotalColumn(column);
      }
      let percent = (Number(value) / total) * 100;
      percent = Formatter.formatNumber(percent);

      return Number(percent) === 0 ? '' : `${percent}%`;
    },

    calculateTotalRow(row, index) {
      let total = 0;

      for (const key in row) {
        if (key != 'type' && key != 'bysel') {
          total += parseFloat(
            row[key] === null || isNaN(row[key]) ? 0 : row[key]
          );
        }
      }

      this.totals[index] = parseFloat(total);

      return total;
    },

    calculateTotalColumn(column) {
      let total = 0;

      if (column != 'all') {
        this.table_data.forEach((row) => {
          if (row[column]) {
            total += parseFloat(
              row[column] === null || isNaN(row[column]) ? 0 : row[column]
            );
          }
        });
      } else {
        this.totals.forEach((elem) => {
          total += parseFloat(elem === null || isNaN(elem) ? 0 : elem);
        });
      }

      return total;
    },

    loadData() {
      let data = {
        type: this.ringingJournalForm.type,
        farms: this.ringingJournalForm.farms,
        init:
          parseInt(this.ringingJournalForm.year_sel_init) * 100 +
          parseInt(this.ringingJournalForm.week_sel_init),
        end:
          parseInt(this.ringingJournalForm.year_sel_end) * 100 +
          parseInt(this.ringingJournalForm.week_sel_end),
        bySel: this.ringingJournalForm.bySel,
        percentage: this.percentage,
      };

      switch (this.ringingJournalForm.bySel) {
        case 'year':
          data.init = parseInt(this.ringingJournalForm.year_sel_init);
          data.end = parseInt(this.ringingJournalForm.year_sel_end);
          break;
        case 'monthrange':
          data.init = parseInt(moment(this.rangeDate[0]).format('MM'));
          data.end = parseInt(moment(this.rangeDate[1]).format('MM'));
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    exportToPDF() {
      let data = this.loadData();
      data.route = 'ringings/journals/reports/pdf';
      data.name_file = `${i18n.t('production.ringin_report')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      let data = this.loadData();
      data.route = 'ringings/journals/reports/excel/';
      data.name_file = `${i18n.t('production.ringin_report')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    setRingings() {
      if (this.flag) {
        this.flag;
        this.titleCard =
          this.ringingJournalForm.type == 0
            ? i18n.t('common_words.consolidated_ringing')
            : i18n.t('common_words.detailed_ringing');
      }
    },

    loadRingingJournalReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'ringings/journals/reports';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            this.flag = response.data;
            try {
              this.setRingings();
            } catch (error) {
              console.log('error: ', error);
            }
            this.totals = [];
            this.table_columns = response.data.table_columns;
            this.table_data = response.data.table_data;
            this.ringingJournal = true;

            this.table_data = this.table_data.map((item) => {
              let result = {};
              Object.entries(item).forEach(([key, value]) => {
                if (value !== null && value !== '') result[key] = value;
              });
              return result;
            });

            this.table_columns = this.table_columns.filter(
              (item) => item.prop !== null
            );
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    isYearSelRequired() {
      return this.interval == 'Semana';
    },

    isWeekSekRequired() {
      return this.interval == 'Semana';
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);

      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = this.concatAll(response.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('calendars/getyearsbusiness').then((response) => {
      this.years = response.data;
      this.showHideLoading();
    });

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('ringings');
  },

  destroyed() {
    this.deselectedItemOnMenu('ringings');
  },
};
</script>
<style scoped>
.table-responsive {
  max-height: 80vh;
}

.cusmtom-thead-color {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
